const cache = {
    saveEx(key, time, data) {
        const saveTime = Math.floor(Date.now() / 1000);
        const _data = {
            time,
            saveTime,
            data
        };
        this.save(key, JSON.stringify(_data));
    },

    getEx(key) {
        const getTime = Math.floor(Date.now() / 1000);
        const res = this.get(key);
        
        if (res) {
            const data = JSON.parse(res);
            if ((getTime - data.saveTime) < data.time) {
                return data.data;
            }
        }
        return null;
    },

    get(key) {
        try {
            const value = localStorage.getItem(key);
            return value || null;
        } catch (e) {
            console.error('缓存读取失败:', e);
            return null;
        }
    },

    save(key, value) {
        try {
            localStorage.setItem(key, value);
            return true;
        } catch (e) {
            console.error('缓存保存失败:', e);
            return false;
        }
    },

    del(key) {
        try {
            localStorage.removeItem(key);
            return true;
        } catch (e) {
            console.error('缓存删除失败:', e);
            return false;
        }
    }
};

export default cache;